var map = {
	"./en.json": 852,
	"./fr.json": 853,
	"./he.json": 854,
	"./realEstate.json": 473,
	"./ru.json": 855
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3277;



//////////////////
// WEBPACK FOOTER
// ./src/translations/description ^\.\/.*\.json$
// module id = 3277
// module chunks = 0